import { apiV2 } from './axios';

export interface RelayApplicationStatus {
  IDField?: string; 
  accountID: string;
  relayApplicationID: string;
  relayApplicationStatus: string;
  documentsUploaded: any;
  createdAt: string;
  updatedAt: string;
}

export const createRelayAccountApplication = async (businessId: string) => {
  const { data } = await apiV2.post<{ data: RelayApplicationStatus }>(`relay-banking/${businessId}/application`);
  return data;
}

export const getRelayAccountApplication = async (businessId: string) => {
  const { data } = await apiV2.get<RelayApplicationStatus>(`relay-banking/${businessId}/application`);
  return data;
}
